import { type UseStorageOptions } from '@meterup/common';
import {
  getLocalStorage as getBaseLocalStorage,
  useLocalStorage as useBaseLocalStorage,
} from '@meterup/common';

import { logError } from '../utils/logError';

export function getLocalStorage<T>(key: string, initialValue: T, options?: UseStorageOptions<T>) {
  return getBaseLocalStorage(key, initialValue, { logError, ...options });
}

export function useLocalStorage<T>(key: string, initialValue: T, options?: UseStorageOptions<T>) {
  return useBaseLocalStorage(key, initialValue, { logError, ...options });
}
